import { getDashboard } from '@apis'
import { useQuery } from '@tanstack/react-query'

const useGetDashboardSummary = (plant_id) => {
  return useQuery({
    enabled: Boolean(plant_id),
    queryFn: () => getDashboard(plant_id),
    queryKey: ['dashboardSummary', { plant_id: plant_id }],
  })
}

export default useGetDashboardSummary
